import { convertLoyaltyEstimate } from 'actions/loyalty/LoyaltyConverter';
import { LoyaltyEstimateRequestDto, LoyaltyEstimateResponseDto } from 'actions/loyalty/LoyaltyDtos';
import { ApiPublicClient } from 'api/ApiClient';
import { emptyLoyaltyEstimate, LoyaltyEstimate } from 'types/Loyalty';

const loyaltyEstimateUrl = 'loyalty/estimate';

/**
 * Calls the public, unauthenticated Loyalty estimate endpoint.
 *
 * The endpoint never returns a 4xx — Loyalty off / marketplace not found / errors
 * all degrade to a disabled, zeroed estimate. Any transport-level failure is
 * treated identically so the estimate can never block the booking flow.
 */
export const fetchLoyaltyEstimate = async (
    request: LoyaltyEstimateRequestDto
): Promise<LoyaltyEstimate> => {
    try {
        const { data } = await ApiPublicClient.post<LoyaltyEstimateResponseDto>(
            loyaltyEstimateUrl,
            request
        );

        return convertLoyaltyEstimate(data);
    } catch (error) {
        console.error(error);

        return emptyLoyaltyEstimate;
    }
};
